import React from 'react';
import { t } from 'ttag';

import TabLayout from '@components/TabLayout';
import People from '@pages/People/List';
import { PeopleProfileMode } from '@pages/People/types';

export const Search = () => (
  <TabLayout title={t`Print Badges only`}>
    <People mode={PeopleProfileMode.PrintBadge} />
  </TabLayout>
);
